import { CollectionDataLoaded, CollectionEvent } from '@news-mono/web-common'
import React from 'react'
import { Lima } from '../../collections/Lima/Lima'
import { Box } from '../../compositions/Box/Box'
import { SearchForm } from '../SearchForm/SearchForm'
import {
    StyledHeading,
    StyledMessage,
    StyledSearchTerm,
} from './SearchResults.styled'

export interface SearchResultsProps {
    results: CollectionDataLoaded
    searchTerm: string
    onEvent: (event: CollectionEvent) => void
}

export const SearchResults = ({
    results,
    searchTerm,
    onEvent,
}: SearchResultsProps) => {
    const hasSearchResults = results.publications.length >= 1
    if (hasSearchResults) {
        return (
            <Box verticalSpacing="lg" hasTopSpacing={true}>
                <SearchForm mountsWithValue={searchTerm} isLarge={true} />

                <StyledMessage>
                    Results for{' '}
                    <StyledSearchTerm>{searchTerm}</StyledSearchTerm>
                </StyledMessage>

                <Lima
                    verticalSpacing="md"
                    fixedRatios={['16:9']}
                    expectedCards={results.publications.length}
                    items={{ loaded: true, result: results.publications }}
                    intermediateColumns={1}
                    initialColumns={1}
                    finalColumns={1}
                    fontScale={0.88}
                    cardLayout={[
                        [
                            {
                                type: 'landscape',
                                format: 'landscape-full-timestamp',
                            },
                        ],
                    ]}
                    remainingCardLayout={{
                        type: 'landscape',
                        format: 'landscape-full-timestamp',
                    }}
                    containerWidthRatios={{ mobile: 1, tablet: 1, desktop: 1 }}
                    onEvent={onEvent}
                />
            </Box>
        )
    }

    if (searchTerm) {
        return (
            <Box verticalSpacing="lg" hasTopSpacing={true}>
                <SearchForm mountsWithValue={searchTerm} isLarge={true} />

                <StyledMessage>
                    Sorry, we couldn't find any search results for
                    <StyledSearchTerm> {searchTerm}</StyledSearchTerm>
                </StyledMessage>
            </Box>
        )
    } else {
        return (
            <Box verticalSpacing="lg" hasTopSpacing={true}>
                <StyledHeading>Search</StyledHeading>
                <SearchForm mountsWithValue={searchTerm} isLarge={true} />
            </Box>
        )
    }
}
SearchResults.displayName = 'SearchResults'
